import { translate } from "react-switch-lang";
import NewHeader from "./newHeader";
import TopBanner from "./TopBanner";
import About_manashakti from "./About_manashakti";
import Stagelife from "./Stagelife";
import Journey from "./Journey";
import Guidance from "./Guidance";
import Mind from "./Mind";
// import NewFooter from "./newFooter";
import MindGymSection from "./components/MindGymSection";
import OnlineLearningSection from "./components/OnlineLearningSection";
import HomeTestimonialsSection from "./components/HomeTestimonialsSection";
import React, { useEffect, useState } from "react";
import * as myConstClass from "./constant.js";
import ExploreMoreSection from "./components/ExploreMoreSection.jsx"
import HomeNewsSection from "./components/HomeNewsSection.jsx";
// import { Link } from "react-router-dom";
import HomeFirstThinkerSection from "./components/HomeFirstThinkerSection.jsx";
import HomeUpcomingCoursesSection from "./components/HomeUpcomingCoursesSection.jsx";
import HomeExploreTopicsSection from "./components/HomeExploreTopicsSection.jsx";
import Footer from "./Footer.js";
import HomeCommunityCallToAction from "./components/HomeCommunityCallToAction.jsx";


import { getLanguage } from 'react-switch-lang';

const NewHomePage = (props) => {
  const { t } = props;
  // Track language state, like About_manashakti
  const [lang, setLang] = useState(() => getLanguage() || 'en');

  useEffect(() => {
    const checkLang = () => {
      const current = getLanguage() || 'en';
      setLang(prev => prev !== current ? current : prev);
    };
    checkLang();
    const interval = setInterval(checkLang, 500);
    window.addEventListener('storage', checkLang);
    return () => {
      clearInterval(interval);
      window.removeEventListener('storage', checkLang);
    };
  }, []);

  return(
    <div>
      <NewHeader {...(typeof window !== 'undefined' && window.lang ? { lang: window.lang } : {})} />
      <TopBanner lang={lang} />
      <About_manashakti />
      <Stagelife />
      <Journey />
      <Guidance />
      <Mind />
      <HomeExploreTopicsSection/>
      <HomeUpcomingCoursesSection/>
      <MindGymSection />
      <OnlineLearningSection/>
      <HomeCommunityCallToAction
        lang={lang}
        title="Manashakti WhatsApp Group"
        description="Connect with like-minded parents, share experiences, and get support throughout your journey. Join our WhatsApp Group for daily tips, guidance, and inspiration."
        buttonText="Join Group"
        whatsappLink="https://chat.whatsapp.com/KDG9e2lBT1p3Sx2zL4RKug"
      />
      <HomeTestimonialsSection
        style={{ backgroundColor: "#ffffff" }}
        userId={localStorage.getItem("user_id") || 0}
      />
      <ExploreMoreSection/>
      <HomeNewsSection/>
      <HomeFirstThinkerSection/>
      <Footer />
    </div>
  );
};

export default translate(NewHomePage);
